import { render, staticRenderFns } from "./ChatElement.vue?vue&type=template&id=47fc3894&scoped=true&"
import script from "./ChatElement.vue?vue&type=script&lang=js&"
export * from "./ChatElement.vue?vue&type=script&lang=js&"
import style0 from "./ChatElement.vue?vue&type=style&index=0&id=47fc3894&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47fc3894",
  null
  
)

export default component.exports